export enum LanguageCode {
    EN = 'EN',
    CS = 'CS',
    SK = 'SK',
  }